import { useFormContext, useWatch } from "react-hook-form";

import { Filter } from "@/constants";
import { FilterOption } from "@/types/FilterOptions";

const formatLabels = (labels: string | string[]) =>
  Array.isArray(labels) ? labels.join(", ") : labels;

const hopefullyGetLabel = ([value, label]: FilterOption) => label || value;

const collectLabels = (options: FilterOption[]) =>
  options.map(hopefullyGetLabel);

/**
 * Returns the label of one or more picked options from a given field name,
 * must be rendered within the Filter form.
 * */

const useOptionLabel = (name: Filter, options?: FilterOption[]) => {
  const { control } = useFormContext();
  // Extract the field value in the current form
  const fieldValue = useWatch({ control, name });
  if (!fieldValue) return null;

  // If there are no options we have to return the values directly instead
  if (!options) {
    return formatLabels(fieldValue);
  }
  // If there's only one option we can assume that it's active:
  if (options?.length === 1) {
    return formatLabels(collectLabels(options));
  }

  // Get all the options that are currently chosen

  const chosen =
    options.filter(([value]) =>
      Array.isArray(fieldValue)
        ? fieldValue.includes(value)
        : value === fieldValue
    ) || [];

  // Pick label if there is one, else display the value itself
  const labels = collectLabels(chosen);

  return formatLabels(labels);
};
export default useOptionLabel;
